"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILHighlightTile = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var il_button_common_1 = require("../il-button/il-button.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var ILHighlightTile = function (props) {
    var sx = props.sx, children = props.children, highlightIcon = props.highlightIcon, disableRipple = props.disableRipple, other = __rest(props, ["sx", "children", "highlightIcon", "disableRipple"]);
    var iconHighlighted = highlightIcon || (react_1.default.createElement(il_icon_common_1.SolidIcon, { sx: {
            bottom: '20px',
            position: 'absolute',
            right: '7px',
            color: 'primary.contrastText',
        }, icon: solid_icon_definitions_1.SolidIconDefinitions.CHECK }));
    return (react_1.default.createElement(il_button_common_1.IconTileButton, __assign({ disableRipple: disableRipple, className: props.active ? 'active' : '', sx: __assign(__assign(__assign({ m: 1, borderRadius: '1rem', backgroundColor: 'background.default', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', boxShadow: 3, position: 'relative' }, (props.active && {
            borderColor: 'primary.dark',
            borderWidth: '0.25rem',
            borderStyle: 'solid',
        })), { minHeight: '4rem' }), sx) }, other),
        !!props.active && (react_1.default.createElement(material_1.Box, { sx: {
                position: 'absolute',
                top: 0,
                right: 0,
                borderTop: '48px solid',
                borderTopColor: 'primary.dark',
                borderLeft: '48px solid transparent',
            } }, iconHighlighted)),
        children));
};
exports.ILHighlightTile = ILHighlightTile;
